import { render, staticRenderFns } from "./KycFileModal.vue?vue&type=template&id=6171777e&scoped=true&"
import script from "./KycFileModal.vue?vue&type=script&lang=js&"
export * from "./KycFileModal.vue?vue&type=script&lang=js&"
import style0 from "./KycFileModal.vue?vue&type=style&index=0&id=6171777e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171777e",
  null
  
)

export default component.exports